import { Box, Flex, Image as ImageComponent, Text } from '@chakra-ui/react';
import Head from 'next/head';
import router from 'next/router';
import React from 'react'
import { AboutCard } from '../../components/AboutUs/aboutCard';
import { BreadCrumb } from '../../components/AppHeader/BreadCrumb';
import { PerformanceBanner, RatingBanner } from '../../components/Banner';
import { PrimaryButton } from '../../components/button';
import { TrustedCompanies } from '../../components/Landing';
import { investorFaq, otherListingProperties, otherListingPropertiesTools } from '../../data';
import { WrapperStyle } from '../../styles/newDesignStyles';
import { HeaderText, RealtorsHeader, RealtorsSemiHeader, SemiHeaderText } from '../../styles/typography';

const InvestorBuyers = () => {
    return (
        <>

            <Head>
                <title key="title">Investors - Business and Commercial Real Estate Listings</title>
                <meta key="description" name="description" content="Discover listings you won’t find anywhere else. Buy or invest in the most ideal property for you. Connect with sellers directly. Sign up free." />
                <meta key="og:title" property="og:title" content='Investors - Business and Commercial Real Estate Listings' />
                <meta key="og:description" property="og:description" content="Discover listings you won’t find anywhere else. Buy or invest in the most ideal property for you. Connect with sellers directly. Sign up free." />

                <link key="fav1" rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
                <link key="fav2" rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
                <link key="fav3" rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
                <link key="fav5" rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#5bbad5" />
                <link key="fav6" rel="shortcut icon" href="/favicons/favicon.ico" />
                <link rel="canonical" href="https://zonado.com/who-we-help/investors-buyers" />
                <meta key="msFav" name="msapplication-TileColor" content="#2d89ef" />
                <meta name="msapplication-config" content="favicons/browserconfig.xml" />
                <meta name="theme-color" content="#ffffff" />

            </Head>

            <WrapperStyle>

                {/* breadcrumb */}
                <BreadCrumb to={"Investors"} />

                <Flex flexDir={{ base: "column", md: "row" }} mt={{ md: "0", lg: "50px" }} justifyContent={"space-between"} alignItems={"center"}>
                    <Flex
                        // px={{ md: "0", lg: "50px" }}
                        py={{ base: "68px", md: "33px", lg: "26px" }}
                        flexDir={"column"} w={{ md: "40%", lg: "49%" }}

                    >
                        <HeaderText text={"Opportunities you won’t find anywhere else"} />
                        <SemiHeaderText
                            text={"A big share of Businesses and Commercial Real Estate are transacted privately. This means that it never hits MLS. Explore Zonado for these public & private listings all in one place and contact the sellers directly ."}
                        />

                        <PrimaryButton
                            mb={"36px"} label={"Access listings"}
                            mr={"auto"} mt={"43px"}
                            onClick={() => router.push("/listings")}
                        />

                    </Flex>

                    <Box w={{ md: "40%" }} py={"14px"} pr={"11px"}>
                        <ImageComponent src={"/images/newLanding/investorBanner.svg"} h={"100%"} objectFit={"contain"} />
                    </Box>
                </Flex>

                <Flex flexDir={"column"} mt={"50px"} >
                    <Text color={"gray.500"} fontSize={"16px"}>Trusted by</Text>

                    <Flex flexDir={"row"} mt={"23px"} className={"trustedCompanies"}>
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image_2.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 4.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/Vector.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 30.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 7.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 3.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 6.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 22.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 5.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 8.svg"} />
                    </Flex>
                </Flex>

                <Box mt={"96px"}>
                    <RealtorsHeader
                        text={"All your buying, selling and lead prospecting on 1 platform"}
                    />
                    <RealtorsSemiHeader text={"Industry platforms limit Brokers from sharing their listings, leaving them restricted and limited in reach. Zonado connects buyers, private investors, Realtors with Business Brokers across the nation."}
                    />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingProperties.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* performance banner */}
                <PerformanceBanner noHeader />

                {/* broker tools  */}
                <Box>
                    <RealtorsHeader text={"A Powerful Broker Suite of Tools"} />
                    <RealtorsSemiHeader text={"Zonado was built as a result of intensive user interviews with investors from across Canada. The result is a suite of elegant solutions to power your workflow"} />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingPropertiesTools.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* ratings banner */}
                <RatingBanner
                    ratingImg={"/images/newLanding/investorTestimony.png"}
                    ratingHeader={'Awesome service'}
                    review={<>I spoke to the team at Zonado to post my business for sale, they helped me by creating  great content, great service,
                        <br />Absolutely the best at what they do</>}
                    reviewer={"- Barberholic Barber (Ottawa)"}
                />

            </WrapperStyle>
        </>
    )
}

export default InvestorBuyers;

InvestorBuyers.isProfessional = true;
InvestorBuyers.faq = investorFaq;